export const sortCampaigns = (campaigns, sortValue) => {
  const list = [...(campaigns || [])];
  switch (sortValue) {
    case "name":
      return list.sort((a, b) =>
        String(a.name || "").localeCompare(String(b.name || ""))
      );
    case "budget":
      return list.sort(
        (a, b) => (Number(b.total_price) || 0) - (Number(a.total_price) || 0)
      );
    case "recent":
    default:
      return list.sort((a, b) => {
        const da = new Date(a.created_at).getTime() || 0;
        const db = new Date(b.created_at).getTime() || 0;
        if (db !== da) return db - da;
        return (b.id || 0) - (a.id || 0);
      });
  }
};
